import { createReducer, on } from '@ngrx/store';

import { Brand, BrandDetails, BrandDisplayName } from '../../proto/brandassador';
import {
  actionBrandGet,
  actionBrandGetEmpty,
  actionBrandGetSuccess,
  actionBrandNamesListGet,
  actionBrandNamesListGetSuccess,
  actionBrandsListGet,
  actionBrandsListGetSuccess,
  BrandsActionTypes,
} from './brands.actions';

export interface BrandsState {
  brandUuid: string;
  brand: Brand;
  brands?: BrandDetails[];
  brandIds?: string[];
  brandDisplayNames?: BrandDisplayName[];
  invalidBrandIds?: string[];
  isLoadingBrand?: boolean;
  isLoadingBrandList?: boolean;
}

const initialState: BrandsState = {
  brandUuid: undefined,
  brand: undefined,
  brands: [],
  brandIds: [],
  brandDisplayNames: [],
  invalidBrandIds: [],
  isLoadingBrand: true,
  isLoadingBrandList: true,
};

export const brandReducer = createReducer(
  initialState,
  on(actionBrandsListGetSuccess, (state, action) => {
    return {
      ...state,
      brands: action.payload || [],
      isLoadingBrandList: false,
    };
  }),
  on(actionBrandGetSuccess, (state, action) => {
    return {
      ...state,
      brandUuid: action.brandUuid,
      brand: action.payload,
      isLoadingBrand: false,
    };
  }),
  on(actionBrandGet, (state) => {
    return {
      ...state,
      isLoadingBrand: true,
    };
  }),
  on(actionBrandsListGet, (state) => {
    return {
      ...state,
      isLoadingBrandList: true,
    };
  }),
  on(actionBrandGetEmpty, (state) => {
    return {
      ...state,
      brand: undefined,
      brandUuid: undefined,
      isLoadingBrandList: false,
    };
  }),
  on(actionBrandNamesListGet, (state, action) => {
    return {
      ...state,
      brandIds: action.body.brandIds || [],
      isLoadingBrandList: true,
    };
  }),
  on(actionBrandNamesListGetSuccess, (state, action) => {
    return {
      ...state,
      brandDisplayNames: action.payload.brands || [],
      invalidBrandIds: action.payload.invalidBrandIds || [],
      isLoadingBrandList: false,
    };
  }),
);
